<label class="toggle" [class]="themeService.getTheme()" *ngIf="type === 'classic'">
  <input
    (click)="switchFlag()"
    class="toggle-checkbox"
    type="checkbox">
  <div class="toggle-switch"></div>
  <span class="toggle-label"></span>
</label>
<label class="toggle-new" [class]="themeService.getTheme()" *ngIf="type === 'new'">
  <input
    (click)="switchFlag()"
    class="toggle-checkbox-new"
    type="checkbox">
  <div class="toggle-switch-new"></div>
  <span class="toggle-label-new"></span>
</label>
